export default __webpack_public_path__ + "static/home-plans-background-3c087fc9365b08e9ba01882de93109b5.jpg";